import { Container, Spinner } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import iconApps from "../../assets/images/icon/icon.png";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import { Helmet } from "react-helmet-async";
import AuthLoginForm from "../../components/auth/AuthLoginForm";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, authChecked, isLoading } = useContext(GlobalContext);
  const { t } = useTranslation("auth");
  const [registrationMessage, setRegistrationMessage] = useState("");

  useEffect(() => {
    const isRegistrationFlow = Boolean(location.state?.fromRegistration);
    const message = location.state?.message;

    if (isRegistrationFlow && message) {
      setRegistrationMessage(message);

      // Clear one-time route state so the message does not reappear on later visits.
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.pathname, location.state, navigate]);

  // SSO: sudah login (di console atau di sewoork.com) → langsung masuk.
  if (authChecked && user && !isLoading) {
    return (
      <Navigate
        to={user.console_access === false ? "/onboarding" : "/dashboard"}
        replace
      />
    );
  }

  if (!authChecked) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{t("login.meta_title")}</title>
      </Helmet>
      <LanguageSwitcher placement="floating" syncServer={false} />
      <div className="center-content">
        <Container className="box-shadow">
          <img
            src={iconApps}
            alt={t("logo_alt")}
            style={{
              marginTop: "20px",
              width: "100px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          ></img>
          <h2 className="text-center">{t("login.title")}</h2>
          <Container>
            <AuthLoginForm
              registrationMessage={registrationMessage}
              onDismissMessage={() => setRegistrationMessage("")}
              onRequireRegister={() => navigate("/register")}
              showGoogle
            />
          </Container>
        </Container>
      </div>
    </>
  );
};

export default LoginPage;
